/**
 * deepCopy - performs a deep copy of a JS object by converting it to a string and reparsing it
 * @param obj - any JS object
 * @returns {any} - copy of the object.
 */
export function deepCopy(obj){
    /* this is apparently pretty fast since it happens natively*/
    let objJSONString = JSON.stringify(obj);
    return JSON.parse(objJSONString);
}

/**
 * Returns today's date.
 * @returns {string}
 */
export function getDateString(seperator = '/') {

    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    return mm + seperator + dd + seperator + yyyy;
}

/**
 * Generate a file with the given filename filled with the provided text
 * @param filename - name of file to be generated
 * @param text - text to go into said file
 */
export function download(filename, text) {
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

/**
 * creates a string 80 char long in the form **... {s} ... **
 * @param s - name of the comment header
 * @returns {string}
 */
export function createCommentHeader(s){
    let numberOfStars = 80-s.length-4;
    let numleftStars = ~~(numberOfStars/2);
    let numrightStars = numberOfStars-numleftStars;
    return "/" + "*".repeat(numleftStars) + " " + s + " " + "*".repeat(numrightStars) + "/\n\n";
}

/**
 * Updates the pinStatus array with peripherals selected pins
 * @param peri - The peripheral to get data from
 * @param pinStatus - The list to update with peripheral data
 */
export function updatePinStatus(peri, pinStatus) {
    if (peri.name === "gpio") {
        peri.pinIO.forEach((pinState, pinLocation) => {
            if (pinState === 1 || pinState === 2) {
                pinStatus[pinLocation] = {
                    periName: peri.name,
                    pos: 0
                };
            }
        });
    } else {
		peri.pinSelection.forEach((pinLocation, index) => {
            if (pinLocation !== null) {
                if (Array.isArray(pinLocation)) {
                        pinLocation.forEach(location => {
                            pinStatus[location] = {
                                periName: peri.name,
                                pos: index
                            };
                        });
                } else {
                    pinStatus[pinLocation] = {
                        periName: peri.name,
                        pos: index
                    };
                }
            }
        });
    }
}

export function trunc(s){
    let minLen = 20;
    if (s.length > minLen)
        return s.substring(0,minLen)+'...';
    else
        return s;
}

export function debounce(func, delay) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
}

export function get_version(board_str) {
    if (board_str.match(/ATM33[0-9x]{2}/)) {
        return "X3XX-5"
    } else if (board_str.match(/ATM34[0-9x]{2}/)) {
        return "X4XX-5";
    } else if (board_str.match(/ATM5[0-9x]{3}/)) {
        return "53XX-3";
    } else {
        return "XX-X1X";
    }
}

export const x2xxPlats = ['XX-X1X'];
export const x3xxPlats = ['X3XX-5'];
export const x4xxPlats = ['X4XX-5'];
export const _5xxxPlats = ['53XX-3'];
export const m33Plats = [...x3xxPlats, ...x4xxPlats, _5xxxPlats];
